import angular from 'angular';
import moment from 'moment';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import dateFormatService from '../../../shared/services/DateFormatService';

angular
  .module('cxSettings')
  .controller('UndeleteEmployeeDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'employeeId',
    undeleteEmployeeDialogCtrl,
  ]);

function undeleteEmployeeDialogCtrl($element, $http, appUrls, flySvc, close, employeeId) {
  var vm = this;
  vm.licenceType = 2;

  const today = moment()
    .utc()
    .startOf('day');
  vm.months = 1;
  vm.licenseInformation = {};
  vm.licenses = [];
  vm.licenseId = null;
  vm.loaded = false;

  vm.beginDate = moment.utc(today).toDate();
  vm.endDate = moment
    .utc(today)
    .add(1, 'months')
    .toDate();

  $http.get(appUrls.api + '/api/License/Info').then(({ data }) => {
    vm.licenseInformation = data;
    vm.licenses = [
      ...(data.temporaryLicenses || [])
        .filter(x => !x.userId)
        .map(x => ({
          ...x,
          name: `${dateFormatService.formatDate(x.beginDate)} - ${dateFormatService.formatDate(
            x.endDate,
          )}`,
        }))
        .sort(dynamicSortMultiple('beginDate', 'endDate')),
    ];

    if (vm.licenseInformation.availableLicenses > 0) vm.licenceType = 1;
    if (!vm.licenseInformation.billPerLicense) {
      vm.save();
    } else {
      vm.loaded = true;
    }
  });

  vm.beginDateOptions = {
    minDate: moment.utc(today).toDate(),
  };
  vm.endDateOptions = {
    minDate: moment
      .utc(today)
      .add(1, 'months')
      .toDate(),
    maxDate: moment
      .utc(today)
      .add(7, 'months')
      .toDate(),
  };

  vm.datesChanged = function() {
    if (vm.beginDate) {
      vm.endDateOptions.minDate = moment
        .utc(vm.beginDate)
        .add(1, 'months')
        .toDate();
      vm.endDateOptions.maxDate = moment
        .utc(vm.beginDate)
        .add(6, 'months')
        .toDate();
    }
    if (vm.endDate) {
      if (vm.endDate > vm.endDateOptions.maxDate) {
        vm.endDate = vm.endDateOptions.maxDate;
      }
      if (vm.endDate < vm.endDateOptions.minDate) {
        vm.endDate = vm.endDateOptions.minDate;
      }
      vm.months = moment
        .utc(vm.endDate)
        .diff(moment.utc(vm.beginDate), 'months', true)
        .round(5);
    }
  };
  vm.datesChanged();
  vm.addMonths = function(nr) {
    vm.endDate = moment
      .utc(vm.endDate)
      .add(nr, 'months')
      .toDate();
    vm.datesChanged();
  };
  vm.setDuration = function(nr) {
    vm.endDate = moment
      .utc(vm.beginDate)
      .add(nr, 'months')
      .toDate();
    vm.datesChanged();
  };
  vm.save = function() {
    var model = {
      employeeId,
      license: null,
      buyNewLicense: vm.licenceType === 2 || vm.licenceType === 4,
    };
    if (vm.licenceType === 3) {
      const license = vm.licenses.find(x => x.id === vm.licenseId);
      if (!license) return;
      model.license = license;
    } else if (vm.licenceType === 4) {
      model.license = {
        id: null,
        isTemporary: true,
        beginDate: vm.beginDate,
        endDate: vm.endDate,
      };
    }
    if (model.license) {
      //Dates are required for temp licenses
      if (!model.license.beginDate || !model.license.endDate) return;
      if (model.license.beginDate instanceof Date)
        model.license.beginDate = moment.utc(model.license.beginDate);
      if (model.license.endDate instanceof Date)
        model.license.endDate = moment.utc(model.license.endDate);
    }
    vm.saving = true;

    return $http
      .post(`${appUrls.api}/api/Employee/Undelete`, model)
      .then(({ data }) => {
        $element.modal('hide');
        close(data, 500);
      }, flySvc.error)
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
